import React, { Component } from "react"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import MetaTags from "react-meta-tags"
import { connect } from "react-redux"
import { isEmpty } from "lodash"
import { Col, Container, Row, Button } from "reactstrap"
import { API_URL } from "helpers/api_helper"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"

import { getBirthChart } from "store/projects/actions"
import BirthChart from "./birthChart"
import BirthDetails from "./birthDetails"
import BirthReport from "./birthReport"
import { replaceAll } from "components/Common/Util"
import { getUserRole } from "components/Common/Roles"

class ProjectsOverview extends Component {
  constructor(props) {
    super(props)
    this.state = {
      downloadLoading: false,
    }
    this.handleDownload = this.handleDownload.bind(this)
    this.handleBack = this.handleBack.bind(this)
  }
  componentDidMount() {
    const {
      match: { params },
      onGetProjectDetail,
    } = this.props
    if (params && params.id) {
      onGetProjectDetail(params.id)
    }
  }

  handleBack() {
    //this.props.history.goBack()
    
    let userRoles = {
      user: false,
      groupUser: false,
      productAdmin: false,
    }
    if (sessionStorage.getItem("userRoles")) {
      let savedUserRoles = JSON.parse(sessionStorage.getItem("userRoles"));
      if (savedUserRoles !== undefined) {
        userRoles = savedUserRoles;
      }
    }
    if (userRoles.productAdmin) {
      this.props.history.push("/product/users-birthchart")
    } else {
      this.props.history.push("/birthchart-report")
    }

  }

  // handleDownload(birthChartId) {
  //   console.log("inside the report details method::::::: birth chart report")
  //   try {
  //     const response = getBirthChartPDF(birthChartId)
  //     response.then(response => {
  //       console.log('response : ' + response)
  //       let blob = new Blob([response])
  //       console.log('blob : ' + blob)
  //       let url = window.URL.createObjectURL(blob);
  //       console.log('url : ' + url)
  //       window.open(url)
  //     })
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }


  handleDownload(birthChartId, birthChartName) {
    console.log("inside the report details method::::::: birth chart report")
    console.log("birthChartId", birthChartId)
    console.log("birthChartName", birthChartName)
    let userRoles = {
      user: false,
      groupUser: false,
      productAdmin: false,
    }
    if (sessionStorage.getItem("userRoles")) {
      let savedUserRoles = JSON.parse(sessionStorage.getItem("userRoles"));
      if (savedUserRoles !== undefined) {
        userRoles = savedUserRoles;
      }
    }
    try {
      let birthReportUrl;
      if (userRoles.productAdmin) {
        birthReportUrl = "product/birthChart/PDF"
      } else if (userRoles.user) {
        birthReportUrl = "astro-users/birthChart/PDF"
      } else {
        return;
      }
      const obj = JSON.parse(sessionStorage.getItem("authUser"))
      const config = {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        headers: {
          'Authorization': 'Bearer ' + obj.token
        },
      }
      fetch(`${API_URL}/${birthReportUrl}?id=${birthChartId}`, config)
        .then(response => {
          console.log('response status : ' + response.status)
          if (response.status != 200) {
            return
          }
          const filename = "AIReport_" + replaceAll(birthChartName);
          console.log("filename", filename)
          response.blob().then(blob => {
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement('a');
            a.href = url;
            a.download = filename;
            a.click();
            //window.open(url)
          });
        });
    } catch (error) {
      console.log(error)
    }
  }

  render() {
    let userRoles = getUserRole()
    const { birthChart } = this.props
    console.log("birthChartChanged, ", birthChart)
    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Birth Chart | Kattam - Birth Chart</title>
          </MetaTags>
          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs title="" breadcrumbItem="Artificial Intelligence Report" />

            {!isEmpty(birthChart) && (
              <>
                <div>
                  <Row>
                    <div className="mb-4">
                      <Button
                        type="button"
                        color="primary"
                        className="btn waves-effect waves-light mt-2 me-1 float-end"
                        onClick={() => this.handleDownload(birthChart.id, birthChart.name)}
                      >
                        <i className="bx bx-download me-2" /> Download
                      </Button>
                      <Button
                        type="button"
                        color="primary"
                        className="ml-1 btn waves-effect  mt-2 waves-light"
                        onClick={this.handleBack}
                      >
                        <i className="bx bx-arrow-back me-2" />
                        Go back
                      </Button>
                    </div>
                  </Row>
                  {userRoles.productAdmin && (
                    <>
                      <Row>
                        <Col lg="4">
                          <BirthDetails birthChart={birthChart} />
                        </Col>
                        <Col lg="8">
                          <BirthChart birthChart={birthChart} />
                        </Col>
                      </Row>
                      <Row>
                        <BirthReport reportJson={birthChart.reportJson} />
                      </Row>
                    </>
                  )}
                  {userRoles.user && (
                    <Row>
                      <Col lg="4">
                        <BirthDetails birthChart={birthChart} />
                      </Col>
                      <Col lg="8">
                        <BirthReport reportJson={birthChart.reportJson} />
                      </Col>
                    </Row>
                  )}
                </div>
              </>
            )}
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

ProjectsOverview.propTypes = {
  birthChart: PropTypes.any,
  match: PropTypes.object,
  onGetProjectDetail: PropTypes.func,
  onGetBirthChartPDF: PropTypes.func
}

const mapStateToProps = ({ projects }) => ({
  birthChart: projects.birthChart,
})

const mapDispatchToProps = dispatch => ({
  onGetProjectDetail: id => dispatch(getBirthChart(id)),
  //onGetBirthChartPDF: birthChartId => dispatch(getBirthChartPDF(birthChartId))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ProjectsOverview))
